import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "tabbed-navigation" };
const _hoisted_2 = {
    class: "main-tabs-container",
    ref: "tabsContainer"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
    key: 0,
    class: "sub-tabs-wrapper"
};
const _hoisted_5 = { class: "sub-tabs-container" };
const _hoisted_6 = ["onClick"];
import { ref, computed, watch, onMounted, nextTick } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AccountTypeFilter',
    props: {
        tabs: {},
        modelValue: {},
        subTabValue: {}
    },
    emits: ["update:modelValue", "update:subTabValue", "tab-change", "sub-tab-change"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const selectedTab = ref(props.modelValue ?? null);
        const selectedSubTab = ref(props.subTabValue ?? null);
        const selectedTabEl = ref(null);
        const selectedSubTabEl = ref(null);
        const currentSubTabs = computed(() => {
            const currentTab = props.tabs.find(tab => tab.value === selectedTab.value);
            return currentTab?.subTabs || null;
        });
        watch(() => props.modelValue, (newVal) => {
            selectedTab.value = newVal ?? null;
            scrollSelectedIntoView();
        });
        watch(() => props.subTabValue, (newVal) => {
            selectedSubTab.value = newVal ?? null;
        });
        watch(selectedTab, (newVal) => {
            const currentTab = props.tabs.find(tab => tab.value === newVal);
            if (currentTab?.subTabs && currentTab.subTabs.length > 0) {
                const defaultSubTab = currentTab.subTabs.find(st => st.value === 'all') || currentTab.subTabs[0];
                selectedSubTab.value = defaultSubTab.value;
                emit('update:subTabValue', defaultSubTab.value);
            }
            else {
                selectedSubTab.value = null;
                emit('update:subTabValue', null);
            }
        });
        function handleTabClick(tabValue) {
            selectedTab.value = tabValue;
            emit('update:modelValue', tabValue);
            emit('tab-change', tabValue);
            scrollSelectedIntoView();
        }
        function handleSubTabClick(subTabValue) {
            selectedSubTab.value = subTabValue;
            emit('update:subTabValue', subTabValue);
            emit('sub-tab-change', subTabValue);
            scrollSelectedSubTabIntoView();
        }
        function scrollSelectedIntoView() {
            nextTick(() => {
                if (selectedTabEl.value) {
                    selectedTabEl.value.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
                }
            });
        }
        function scrollSelectedSubTabIntoView() {
            nextTick(() => {
                if (selectedSubTabEl.value) {
                    selectedSubTabEl.value.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
                }
            });
        }
        onMounted(() => {
            scrollSelectedIntoView();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
                        return (_openBlock(), _createElementBlock("button", {
                            key: tab.value,
                            ref_for: true,
                            ref: el => { if (tab.value === selectedTab.value)
                                selectedTabEl.value = el; },
                            class: _normalizeClass(['main-tab-button', { selected: selectedTab.value === tab.value }]),
                            onClick: ($event) => (handleTabClick(tab.value))
                        }, _toDisplayString(tab.label), 11, _hoisted_3));
                    }), 128))
                ], 512),
                _createVNode(_Transition, { name: "sub-tabs" }, {
                    default: _withCtx(() => [
                        (currentSubTabs.value && currentSubTabs.value.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentSubTabs.value, (subTab) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                            key: subTab.value,
                                            ref_for: true,
                                            ref: el => { if (subTab.value === selectedSubTab.value)
                                                selectedSubTabEl.value = el; },
                                            class: _normalizeClass(['sub-tab-button', { selected: selectedSubTab.value === subTab.value }]),
                                            onClick: ($event) => (handleSubTabClick(subTab.value))
                                        }, _toDisplayString(subTab.label), 11, _hoisted_6));
                                    }), 128))
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
